module.exports = __webpack_public_path__ + "img/terroir-wavy-2.a9c11fa1.jpg";